import { render, staticRenderFns } from "./carTypeEcharts.vue?vue&type=template&id=60ed350d&"
import script from "./carTypeEcharts.vue?vue&type=script&lang=js&"
export * from "./carTypeEcharts.vue?vue&type=script&lang=js&"
import style0 from "./carTypeEcharts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports